import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface SuccessViewProps {
  message: string;
  onClose: () => void;
}

const SuccessView: React.FC<SuccessViewProps> = ({ message, onClose }) => (
  <Box sx={{ textAlign: "center", py: 4 }}>
    <CheckCircleIcon sx={{ fontSize: 72, color: "var(--green)", mb: 2 }} />
    <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: "var(--ink)" }}>
      {message}
    </Typography>
    <Typography sx={{ color: "var(--ink-soft)",  mb: 4, maxWidth: 360, mx: "auto" }}>
      Sua assinatura está ativa! Você já pode acessar todas as funcionalidades do sistema.
    </Typography>
    <Button variant="contained" onClick={onClose} size="large"
      sx={{ bgcolor: "var(--green)", "&:hover": { bgcolor: "var(--green)", filter: "brightness(0.93)" }, px: 4 }}
    >
      Finalizar
    </Button>
  </Box>
);

export default SuccessView;
